import { c as _c } from "react/compiler-runtime";
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useIntersection } from 'react-use';
import ProductCardPhotoSliderDots from './ProductCardPhotoSliderDots';
const ProductCardPhotoSliderItem = React.forwardRef((t0, ref) => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== ref) {
    t1 = <div className="aspect-square flex items-center justify-center snap-start min-w-full" ref={ref}>{children}</div>;
    $[0] = children;
    $[1] = ref;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
});
ProductCardPhotoSliderItem.propTypes = {
  children: PropTypes.node
};
const ProductCardPhotoSlider = t0 => {
  const $ = _c(13);
  const {
    image1,
    image2
  } = t0;
  const item2Ref = useRef();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      threshold: 0.6
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const item2Intersection = useIntersection(item2Ref, t1);
  const isItem2Intersecting = item2Intersection?.isIntersecting;
  const activeItem = isItem2Intersecting ? 1 : 0;
  let t2;
  if ($[1] !== image1) {
    t2 = <ProductCardPhotoSliderItem>{image1}</ProductCardPhotoSliderItem>;
    $[1] = image1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== image2) {
    t3 = <ProductCardPhotoSliderItem ref={item2Ref}>{image2}</ProductCardPhotoSliderItem>;
    $[3] = image2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className="aspect-square overflow-x-scroll flex flex-row snap-x snap-mandatory [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">{t2}{t3}</div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== activeItem) {
    t5 = <ProductCardPhotoSliderDots activeItem={activeItem} itemsCount={2} />;
    $[8] = activeItem;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <div className="relative">{t4}{t5}</div>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
ProductCardPhotoSlider.propTypes = {
  image1: PropTypes.node,
  image2: PropTypes.node
};
export default ProductCardPhotoSlider;